import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import { AccountCircle, Email, Face, AssignmentInd, PowerSettingsNew } from '@material-ui/icons';

class LoggedInMenu extends Component {
    state = {
        open: false,
        anchorEl: null,
    };

    handleOpen = (event) => {
        this.setState({
            open: true,
            anchorEl: event.currentTarget
        });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    logOut = () => {
        this.props.onLogoutClick();
        this.handleClose();
    };

    render() {
        const fullName = `${this.props.currentUser.firstName} ${this.props.currentUser.lastName}`;

        return (
            <div>
                <Button
                    aria-owns={'simple-menu'}
                    aria-haspopup="true"
                    onClick={this.handleOpen}
                    color="inherit"
                >
                    <AccountCircle />
                </Button>
                <Menu
                    id="simple-menu"
                    open={this.state.open}
                    anchorEl={this.state.anchorEl}
                    onClose={this.handleClose}
                >
                    <MenuItem disabled>
                        <ListItemIcon>
                            <Face />
                        </ListItemIcon>
                        <ListItemText primary={fullName} />
                    </MenuItem>
                    <MenuItem disabled>
                        <ListItemIcon>
                            <Email />
                        </ListItemIcon>
                        <ListItemText primary={this.props.currentUser.userName} />
                    </MenuItem>
                    <MenuItem disabled>
                        <ListItemIcon>
                            <AssignmentInd />
                        </ListItemIcon>
                        <ListItemText primary={this.props.position} />
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={this.logOut}>
                        <ListItemIcon>
                            <PowerSettingsNew />
                        </ListItemIcon>
                        <ListItemText primary="Logout" />
                    </MenuItem>
                </Menu>
            </div>
        );
    }
}

LoggedInMenu.propTypes = {
    onLogoutClick: PropTypes.func.isRequired,
    currentUser: PropTypes.shape({
        userName: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
    }).isRequired,
    position: PropTypes.string,
};

LoggedInMenu.defaultProps = {
    position: '',
};

export default LoggedInMenu;